/*******************************************************************************
 * AppRoutesProvider */
/**
 * @ngdoc    object
 * @module   app
 * @name     app.object:AppRoutesProvider
 *
 * @description
 * This provider is used to contain information used for routing within the app.
 * It will expose some basic resolve objects for accessing either a public or
 * private route.
 *
 * This provider is intended to be extended via overriding the definition within
 * each route component. For this to work, this definition needs to be ran first
 * and for each override the provider dependency needs to include
 * "AppRoutesProvider" and copy over the existing properties to maintain any
 * defined properties.
 *
 * This style will allow for route configurations to be added from different
 * files before the config phase of the application where the routes need to be
 * defined.
 *******************************************************************************/
export function AppRoutesProvider() {
  /*----------------------*/
  /* Standard Resolutions */
  /*----------------------*/
  var baseResolve = {
    alertClear: (Alert) => Alert.clear()
  };

  /** Required for provider. */
  this.$get = angular.noop;
}

AppRoutesProvider.$inject = [];
